import router from './router'

router.beforeEach((to, from, next) => {
  //start test 免登陆进入工作台
  next();
  return
  // console.log("ssss")
  //  end
	if (localStorage.NEEDLOGIN === 'true') {
		if (to.name === 'Login') {
			// 先撤掉免登陆
			// next({name: 'SellWork'})
			// next({name: 'Work'})
			next()
		} else {
			next()
		}
	} else {
		if (to.name === 'Login') {
			// next({name: 'SellWork'})
			// next({name: 'Work'})
			next()
		} else {
			next({name: 'Login'})
			// next()
		}
	}

	//清除搜索记录
	if ((from.name == 'DoneOrder' || from.name == 'NewOrder' || from.name == 'MarchOrder' || from.name =='CanceledOrder') && to.name !== 'OrderDetails') {
		localStorage.removeItem('sea_ord')
		console.log('清除数据')
	}

})




// WEBPACK FOOTER //
// ./src/needLogin.js